import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { AuthenticatorQrForm } from "./AuthenticatorQrForm";
import { AuthenticatorEnableDisable } from "./AuthenticatorEnableDisable";
import { useNavigate } from "react-router-dom";
import "./Security2FA.scss";

function Security2FA() {
  const [factorAuthEnable, setFactorAuthEnable] = useState();
  const [showQrScaner, setShowQRScanner] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const authenticatorEnable: any = localStorage.getItem("authenticatorEnable");
    const showAuthenticatorQR: any = localStorage.getItem("showAuthenticatorQR");
    setFactorAuthEnable(authenticatorEnable);
    setShowQRScanner(showAuthenticatorQR);
    console.log(`2FA Status : ${factorAuthEnable} , Show QR = ${showQrScaner}`);
  }, []);

  const is2FAEnabled = factorAuthEnable === "true";

  return (
    <div className="security-page">
      <div className="security-card">

        {/* Magenta top accent */}
        {/* <div className="security-card__accent" /> */}

        {/* ── Hero ─────────────────────────────────────────────── */}
        <div className="security-card__hero">
          <div className="security-card__blobs" aria-hidden="true">
            <span className="security-card__blob security-card__blob--1" />
            <span className="security-card__blob security-card__blob--2" />
            <span className="security-card__blob security-card__blob--3" />
          </div>

          {/* Live status badge */}
         

          {/* Lock animation */}
          <div className="security-card__gif-wrap">
            <Image
              src="/lock.gif"
              width={120}
              height={120}
              alt="2FA Security"
              preview={false}
            />
          </div>
           <div className={`security-card__status-badge ${is2FAEnabled ? "security-card__status-badge--on" : "security-card__status-badge--off"}`}>
            <span className="security-card__status-dot" />
            {is2FAEnabled ? "2FA Enabled" : "2FA Disabled"}
          </div>

          <h2 className="security-card__title">2-Step Verification</h2>
          <p className="security-card__desc">
            Enhance your account security with two-factor authentication —
            a one-time password keeps your login safe and secure.
          </p>
        </div>

        {/* ── Trust indicators ─────────────────────────────────── */}
        <div className="security-card__indicators">
          <div className="security-card__indicator">
            <span>🔐</span>
            <span>End-to-end encrypted</span>
          </div>
          <div className="security-card__indicator-divider" />
          <div className="security-card__indicator">
            <span>⏱️</span>
            <span>30-second OTP</span>
          </div>
          <div className="security-card__indicator-divider" />
          <div className="security-card__indicator">
            <span>📱</span>
            <span>Authenticator app</span>
          </div>
        </div>

        {/* ── Divider ──────────────────────────────────────────── */}
        <div className="security-card__divider" />

        {/* ── Form content ─────────────────────────────────────── */}
        <div className="security-card__body">
          {showQrScaner === "true" ? (
            <AuthenticatorQrForm />
          ) : (
            <AuthenticatorEnableDisable factorAuthEnable={factorAuthEnable} />
          )}
        </div>

      </div>
    </div>
  );
}

export default Security2FA;